export const environment = {
	production: false,
	authApiUrl: process.env.REACT_APP_AUTH_API,
	partnerApiUrl: process.env.REACT_APP_PARTNER_API,
	userApiUrl: process.env.REACT_APP_USER_API,
	invoiceApiUrl: process.env.REACT_APP_INVOICE_API,
	notificationApiUrl: process.env.REACT_APP_NOTIFICATION_API,
	apiUrl: process.env.REACT_APP_API_URL
};
